import LazyLoad from 'vanilla-lazyload';

const lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy"
});
window.lazyLoadInstance = lazyLoadInstance; // <-- Rende globale